import React from 'react';
import './BClients.css';

function BClients() {
  const clients = [
    { name: 'San Isidro', logo: '/logo-st-isidro.png' },
    { name: 'JumpIn', logo: '/LogoJumpIn.png' },
    { name: 'Pentafon', logo: '/LogoPentafon.png' }
  ];

  // Debug: verificar si las imágenes cargan
  React.useEffect(() => {
    clients.forEach(client => {
      const img = new Image();
      img.src = client.logo;
      img.onerror = () => console.error(`Error cargando: ${client.logo}`);
      img.onload = () => console.log(`Cargado correctamente: ${client.logo}`);
    });
  }, []);

  return (
    <section className="b-clients-section">
      
      <div className="clients-carousel">
        <div className="clients-track">
          {/* Primera ronda de logos */}
          {clients.map((client, index) => (
            <div className="client-logo" key={`first-${index}`}>
              <img src={client.logo} alt={client.name} />
            </div>
          ))}
          
          {/* Segunda ronda (duplicada para efecto infinito) */}
          {clients.map((client, index) => (
            <div className="client-logo" key={`second-${index}`}>
              <img src={client.logo} alt={client.name} />
            </div>
          ))}
          
          {/* Tercera ronda (para mayor fluidez) */}
          {clients.map((client, index) => (
            <div className="client-logo" key={`third-${index}`}>
              <img src={client.logo} alt={client.name} />
            </div>
          ))}
          
          {/* Cuarta ronda (para mayor fluidez) */}
          {clients.map((client, index) => (
            <div className="client-logo" key={`fourth-${index}`}>
              <img src={client.logo} alt={client.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BClients;